export default __webpack_public_path__ + "static/media/dot_matrix1.10875bed.svg";